module.exports = __webpack_public_path__ + "img/1497160723.ecb8c948.jpg";